import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import styles from './SlotSettings.module.scss'
import slotsScheduleSettingsStore from 'Stores/slotsScheduleSettingsStore'
import { findOption } from 'components/Modules/Slots/utils'
import CounterInput from 'components/UI/CounterInput/CounterInput'
import FormField from 'components/UI/AsideModal/Form/FormField'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'

const Postfix = {
  MINUTE: 1,
  HOUR: 60,
  DAY: 1440,
}
const gapOptions = [
  { value: Postfix.MINUTE, label: 'мин.' },
  { value: Postfix.HOUR, label: 'часов' },
  { value: Postfix.DAY, label: 'дней' },
]

function TimeGap() {
  const {
    timeGap = { value: 1, postfix: Postfix.MINUTE },
    setTime,
    editingData,
  } = slotsScheduleSettingsStore

  const handleTimeGapChange = (newValue) => {
    setTime({ value: newValue, postfix: timeGap.postfix }, 'timeGap')
  }
  const handlePostFixChange = (option) => {
    const postfix = option.value
    setTime({ value: timeGap.value, postfix }, 'timeGap')
  }

  useEffect(() => {
    let value = timeGap.value
    let postfix = timeGap.postfix
    if (value < Postfix.HOUR || value % Postfix.HOUR !== 0) {
      return
    }

    const isHour = value >= Postfix.HOUR && value < Postfix.DAY
    const isDay = value >= Postfix.DAY
    const isNotWholeDay = timeGap.value % Postfix.DAY !== 0

    if (isHour) {
      value = value / Postfix.HOUR
      postfix = Postfix.HOUR
    }
    if (isDay) {
      value = value / Postfix.DAY
      postfix = Postfix.DAY
      if (isNotWholeDay) {
        value = timeGap.value / Postfix.HOUR
        postfix = Postfix.HOUR
      }
    }
    setTime({ value, postfix }, 'timeGap')
  }, [editingData, timeGap, setTime])

  return (
    <FormField>
      <FormLabel>Клиент может записаться не позднее</FormLabel>
      <div className={styles.timeBlock}>
        <CounterInput
          value={timeGap.value}
          min={1}
          max={200}
          step={1}
          name='timeGap'
          onChange={handleTimeGapChange}
        />

        <SelectCustom
          placeholder='Без перерыва'
          options={gapOptions}
          value={findOption(timeGap.postfix, gapOptions)}
          onChange={handlePostFixChange}
          classes={styles.time_gap_select}
        />
      </div>
      <span className={styles.time_gap_text}>до старта слота</span>
    </FormField>
  )
}

export default observer(TimeGap)
